// Defining and Exporting a list of countries names and iso-code to be used in insurance form

export const COUNTRIES = {
  Africa: [
    ['DZ', 'Algeria'], ['AO', 'Angola'], ['BJ', 'Benin'], ['BW', 'Botswana'], ['BF', 'Burkina'], ['BI', 'Burundi'],
    ['CM', 'Cameroon'], ['CV', 'Cape Verde'], ['CF', 'Central African Republic'], ['TD', 'Chad'], ['KM', 'Comoros'],
    ['CG', 'Congo'], ['CD', 'Congo, Democratic Republic of'], ['DJ', 'Djibouti'], ['EG', 'Egypt'],
    ['GQ', 'Equatorial Guinea'], ['ER', 'Eritrea'], ['ET', 'Ethiopia'], ['GA', 'Gabon'], ['GM', 'Gambia'],
    ['GH', 'Ghana'], ['GN', 'Guinea'], ['GW', 'Guinea-Bissau'], ['CI', 'Ivory Coast'], ['KE', 'Kenya'],
    ['LS', 'Lesotho'], ['LR', 'Liberia'], ['LY', 'Libya'], ['MG', 'Madagascar'], ['MW', 'Malawi'], ['ML', 'Mali'],
    ['MR', 'Mauritania'], ['MU', 'Mauritius'], ['MA', 'Morocco'], ['MZ', 'Mozambique'], ['NA', 'Namibia'],
    ['NE', 'Niger'], ['NG', 'Nigeria'], ['RW', 'Rwanda'], ['ST', 'Sao Tome and Principe'], ['SN', 'Senegal'],
    ['SC', 'Seychelles'], ['SL', 'Sierra Leone'], ['SO', 'Somalia'], ['ZA', 'South Africa'], ['SS', 'South Sudan'],
    ['SD', 'Sudan'], ['SZ', 'Swaziland'], ['TZ', 'Tanzania'], ['TG', 'Togo'], ['TN', 'Tunisia'], ['UG', 'Uganda'],
    ['ZM', 'Zambia'], ['ZW', 'Zimbabwe']
  ],
  Asia: [
    ['AF', 'Afghanistan'], ['BH', 'Bahrain'], ['BD', 'Bangladesh'], ['BT', 'Bhutan'], ['BN', 'Brunei'],
    ['MM', 'Burma (Myanmar)'], ['KH', 'Cambodia'], ['CN', 'China'], ['TP', 'East Timor'], ['IN', 'India'],
    ['ID', 'Indonesia'], ['IR', 'Iran'], ['IQ', 'Iraq'], ['IL', 'Israel'], ['JP', 'Japan'], ['JO', 'Jordan'],
    ['KZ', 'Kazakhstan'], ['KP', 'Korea, North'], ['KR', 'Korea, South'], ['KW', 'Kuwait'], ['KG', 'Kyrgyzstan'],
    ['LA', 'Laos'], ['LB', 'Lebanon'], ['MY', 'Malaysia'], ['MV', 'Maldives'], ['MN', 'Mongolia'], ['NP', 'Nepal'],
    ['OM', 'Oman'], ['PK', 'Pakistan'], ['PH', 'Philippines'], ['QA', 'Qatar'], ['RU', 'Russian Federation'],
    ['SA', 'Saudi Arabia'], ['SG', 'Singapore'], ['LK', 'Sri Lanka'], ['SY', 'Syria'], ['TJ', 'Tajikistan'],
    ['TH', 'Thailand'], ['TR', 'Turkey'], ['TM', 'Turkmenistan'], ['AE', 'United Arab Emirates'], ['UZ', 'Uzbekistan'],
    ['VN', 'Vietnam'], ['YE', 'Yemen']
  ],
  Europe: [
    ['AL', 'Albania'], ['AD', 'Andorra'], ['AM', 'Armenia'], ['AT', 'Austria'], ['AZ', 'Azerbaijan'], ['BY', 'Belarus'],
    ['BE', 'Belgium'], ['BA', 'Bosnia and Herzegovina'], ['BG', 'Bulgaria'], ['HR', 'Croatia'], ['CY', 'Cyprus'],
    ['CZ', 'Czech Republic'], ['DK', 'Denmark'], ['EE', 'Estonia'], ['FI', 'Finland'], ['FR', 'France'],
    ['GE', 'Georgia'], ['DE', 'Germany'], ['GR', 'Greece'], ['HU', 'Hungary'], ['IS', 'Iceland'], ['IE', 'Ireland'],
    ['IT', 'Italy'], ['LV', 'Latvia'], ['LI', 'Liechtenstein'], ['LT', 'Lithuania'], ['LU', 'Luxembourg'],
    ['MK', 'Macedonia'], ['MT', 'Malta'], ['MD', 'Moldova'], ['MC', 'Monaco'], ['ME', 'Montenegro'],
    ['NL', 'Netherlands'], ['NO', 'Norway'], ['PL', 'Poland'], ['PT', 'Portugal'], ['RO', 'Romania'],
    ['SM', 'San Marino'], ['RS', 'Serbia'], ['SK', 'Slovakia'], ['SI', 'Slovenia'], ['ES', 'Spain'],
    ['SE', 'Sweden'], ['CH', 'Switzerland'], ['UA', 'Ukraine'], ['GB', 'United Kingdom'], ['VAT', 'Vatican City']
  ],
  'North-America': [
    ['AG', 'Antigua and Barbuda'], ['BS', 'Bahamas'], ['BB', 'Barbados'], ['BZ', 'Belize'], ['CA', 'Canada'],
    ['CR', 'Costa Rica'], ['CU', 'Cuba'], ['DM', 'Dominica'], ['DO', 'Dominican Republic'], ['SV', 'El Salvador'],
    ['GD', 'Grenada'], ['GT', 'Guatemala'], ['HT', 'Haiti'], ['HN', 'Honduras'], ['JM', 'Jamaica'], ['MX', 'Mexico'],
    ['NI', 'Nicaragua'], ['PA', 'Panama'], ['KN', 'Saint Kitts and Nevis'], ['LC', 'Saint Lucia'],
    ['VC', 'Saint Vincent and the Grenadines'], ['TT', 'Trinidad and Tobago'], ['US', 'United States']
  ],
  'South-America': [
    ['AR', 'Argentina'], ['BO', 'Bolivia'], ['BR', 'Brazil'], ['CL', 'Chile'], ['CO', 'Colombia'], ['EC', 'Ecuador'],
    ['GY', 'Guyana'], ['PY', 'Paraguay'], ['PE', 'Peru'], ['SR', 'Suriname'], ['UY', 'Uruguay'], ['VE', 'Venezuela']
  ],
  Oceania: [
    ['AU', 'Australia'], ['FJ', 'Fiji'], ['KI', 'Kiribati'], ['MH', 'Marshall Islands'], ['FM', 'Micronesia'],
    ['NR', 'Nauru'], ['NZ', 'New Zealand'], ['PW', 'Palau'], ['PG', 'Papua New Guinea'], ['WS', 'Samoa'],
    ['SB', 'Solomon Islands'], ['TO', 'Tonga'], ['TV', 'Tuvalu'], ['VU', 'Vanuatu']
  ]
}



// WEBPACK FOOTER //
// ./src/data/countries.js